export enum ApplicationErrorCode {
  INVALID_PERMISSIONS = 310,
  INVALID_BULK_UPLOAD_LICENSES = 400,
  BULK_UPLOAD_PARSE_ERROR_GENERIC = 500,
  BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS = 501,
  BULK_UPLOAD_MAX_RECORD_SIZE = 502,
  BULK_UPLOAD_INCONSISTENT_COLUMNS = 503
}
